export enum ConfigurationTypeNames {
  EMDISConfiguration = "CherryHub.DataPlatform.EbetMetropolis.EMDISConfiguration",
  EbetClientConfiguration = "EbetLoyaltyClient.ClientConfiguration",
  // Temporarily unused with IntegrationIGTAClientConfigurationForm (CH-5330).
  // IGTAClientConfiguration = "IGTAdvantage.MWSClient.ClientConfiguration",
}
